import Modal from "bootstrap/js/src/modal";
import {createElement} from "../util/utils";

const { __ } = wp.i18n;

export default {
  popup: null,
  open(data) {
    if( this.popup ) {
      this.close();
    }

    this.popup = this.createModal(data);

    if('function' === typeof data.onHidden) {
      this.popup._element.addEventListener('hidden.bs.modal', data.onHidden);
    }
    this.popup.show();
  },
  close() {
    if( ! this.popup ) {
      return;
    }
    let el = this.popup._element;

    if( this.popup._isShown ) {
      this.popup.hide();
    }

    this.popup.dispose();
    this.popup = null;
    el.remove();
  },
  createModal(data)
  {
      const modal = createElement({
        classes: ['modal', 'fade'],
        attributes: {
          id: 'popupModal',
          tabindex: '-1',
          ariaHidden: "true",
        },
        parent: document.body,
      });
      const dialog = createElement({
        classes: ['popup-modal', 'modal-dialog', 'modal-dialog-centered'],
        parent: modal,
      });
      const content = createElement({
        classes: ['modal-content', `popup-${data.type}`],
        parent: dialog,
      });
      const header = createElement({
        classes: ['modal-header'],
        parent: content,
      });
      createElement({
        tagname: 'button',
        classes: ['btn-close'],
        attributes: {
          type: 'button',
          ariaLabel: __('Close', 'canopia'),
        },
        dataset: {
          bsDismiss: 'modal',
        },
        parent: header,
      });
      const body = createElement({
        classes: ['modal-body'],
        parent: content,
      });

      if(data.title) {
        createElement({
          tagname: 'h3',
          parent: body,
          textContent: data.title,
        });
      }

      if(data.message) {
        if(Array.isArray(data.message)) {
          data.message.forEach(p => createElement({
            tagname: 'p',
            parent: body,
            textContent: p,
          }))
        } else {
          body.insertAdjacentHTML('beforeend', data.message);
        }
      }

      const footer = createElement({
        classes: ['modal-footer'],
        parent: content,
      });

      if(data.close && data.close.text) {
        createElement({
          tagname: 'button',
          classes: ['btn', 'btn-yellow-green'],
          textContent: data.close.text,
          dataset: {
            bsDismiss: 'modal',
          },
          attributes: {
            type: 'button',
          },
          parent: footer,
        })
      }

      if (data.link && data.link.url && data.link.text){
          createElement({
              tagname: 'a',
              classes: ['btn', 'btn-yellow-green'],
              textContent: data.link.text,
              attributes: {
                  href: data.link.url,
              },
              parent: footer,
          })
      }

      return new Modal(modal);
  },
}
